import React, {useState} from 'react';
import { toast } from 'react-toastify';
import {Button, Header, Image, Form, List, Segment, Icon } from 'semantic-ui-react';
//import {withRouter} from "react-router";
import API, { ResponseManagement} from "../../API";
import Utility, {getUserIdentity} from "../../Utility";
import './LoginBoxSelfCheckin.css';
//import IdleTimer from "react-idle-timer";
import { useIdleTimer } from 'react-idle-timer' 
import useRouter from "../../hooks/useRouter";

/**
 * Chargement page Self CheckIn
 */
const LoginBoxSelfCheckin = (props) => {
  const [stageState, setStageState] = useState('name');
  const [dataBlocIdState, setDataBlocIdState] = useState([]);
  const [clientIdState, setClientIdState] = useState(0);
  const [identityState, setIdentityState] = useState('');

  const router = useRouter();

  /**
   * lors de la soumission de nom de dossier par le client
   * @param event
   */
  const handleSubmitName = (event) => {
    event.preventDefault();
    let form = event.target.closest('form');
    let inputName = document.querySelector("#inputNameSelfCheckin");
    let btn = event.target;

    if (inputName.value.length > 0) {
      if(btn.classList.contains('loading') === false) {
        btn.classList.add('loading');

        let data = new FormData(form);
        data = new URLSearchParams(data);

        API
          .post(`/${router.match.params.token}/${router.match.params.lang}/checkSelfCheckinName`, data)
          .then(response => {
            ResponseManagement(response,
              () => {
                let identity = getUserIdentity(response.data.data.user.civility, response.data.data.user.lastname, response.data.data.user.society, response.data.data.user.firstname)
                setIdentityState(identity);
                setStage('numResa');
                setDataBlocIdState(response.data.data['tabBlocId']);
                setClientIdState(response.data.data['user']['clientId']);
              },
              () => {
                if (response.data.message !== "") {
                  toast.error(props.translations[response?.data?.message]);
                } else {
                  toast.error("error");
                }
              }
            );
            btn.classList.remove('loading');
          })
          .catch((error) => {
            // ErrorManagement(error, () => { });
            if (error !== undefined && error?.response?.data?.message && error.response.data.message !== '') {
              toast.error(props.translations[error.response.data.message]);
            } else {
              toast.error("error");
            }
            btn.classList.remove('loading');
          });
      }
    } else {
      toast.error(props.translations.needName);
    }
  }


  /**
   * lors de la soumission du numéro résa / dossier par le client
   * toast.error ou redirection vers le precheckin
   * @param event
   */
  const handleSubmitNumResa = (event) => {
    event.preventDefault();
    let form = event.target.closest('form');
    let inputNumResa = document.querySelector("#inputNumResaSelfCheckin");
    let btn = event.target;

    if (inputNumResa.value.length > 0) {
      if(btn.classList.contains('loading') === false) {
        btn.classList.add('loading');

        let data = new FormData(form);
        data.set('tabBlocId', JSON.stringify(dataBlocIdState));
        data.set('clientId', JSON.stringify(clientIdState));
        data.set('organizationId', JSON.stringify(props.infosEstablishment.organizationId));
        data = new URLSearchParams(data);

        API
          .post(`/${router.match.params.token}/${router.match.params.lang}/checkSelfCheckinNumResa`, data)
          .then(response => {
            ResponseManagement(response,
              () => {
                /*router.history.push({
                  pathname: `/${response.data.data.temporaryLink.token}/${router.match.params.lang}/preCheckIn/${response.data.data.bookingFolderId}`,
                  state: {
                    isFromSelfCheckin: true,
                    selfCheckinToken: router.match.params.token
                  }
                });*/
                router.navigate( `/${response.data.data.temporaryLink.token}/${router.match.params.lang}/preCheckIn/${response.data.data.bookingFolderId}`,
                  {state: {
                    isFromSelfCheckin: true,
                    selfCheckinToken: router.match.params.token
                  }}
                );
              },
              () => {
                if (response?.data?.message !== "") {
                  toast.error(props.translations[response.data.message]);
                } else {
                  toast.error("error");
                }
              }
            );
            btn.classList.remove('loading');
          })
          .catch((error) => {
            // ErrorManagement(error, () => { });
            if (error !== undefined && error?.response?.data?.message && error.response.data.message !== '') {
              toast.error(props.translations[error.response.data.message]);
            } else {
              toast.error("error");
            }
            btn.classList.remove('loading');
          });
      }
    } else {
      toast.error(props.translations.needName);
    }
  }

  /**
   * Set Stage
   * @param {string} stage
   */
  const setStage = (stage) => {
    let listSlide = document.querySelector('.ui.horizontal.list');
    // setLoginForgotState('');
    if (stage === 'numResa') {
      listSlide.classList.add('transitionStep');
    } else if (stage === 'name') {
      listSlide.classList.remove('transitionStep');
    }
    setStageState(stage);
  }

  /**
   * permet de lancer le focus sur l'input
   * utlisation de Ref semantic pour éviter le querySelector via document
   * @param stage
   */
  const getInputFocus = (stage) => {
    const inputEl = document.querySelector('#input' + Utility.ucFirst(stage) + 'SelfCheckin');

    if (inputEl !== null && typeof inputEl !== "undefined") {
      inputEl.focus();
    }
  }

  /**
   * Retourne le logo de l'etablissement
   * @returns {object} jsx
   */
  const getImage = () => {
    if (props.infosEstablishment && props.infosEstablishment.logo) {
      return <Image style={{ margin: 'auto' }} src={props.infosEstablishment.logo} />
    } else {
      return <Header as="h1">{props.infosEstablishment.nomEtab}</Header>
    }
  }

  /**
   * Click sur le lien pour revenir sur la saisie du nom
   * @param {object} event
   */
  const handleClickUrlBack = (event) => {
    event.preventDefault();
    setStage('name');
  }

  /**
   * Retourne le header
   * @param {string} type
   * @returns {object} jsx
   */
  const getHeader = (type) => {
    let title;

    switch (type) {
      case 'numResa':
        title = identityState.length > 0 ? `${props.translations.hello} ${identityState}` : props.translations.hello;
        break;
      default:
        title = props.translations.fillName;
        break;
    }

    return (
      <p className="step-title">{title}</p>
    )
  }

  /**
   * Retourne le formulaire du nom
   * @returns {object} jsx
   */
  const getFormName = () => {
    return (
      <>
        {getHeader('name')}
          <Form.Input
            fluid
            icon="user"
            iconPosition="left"
            placeholder={props.translations.yourName}
            id="inputNameSelfCheckin"
            name="inputNameSelfCheckin"
          />
        <div className="ui center aligned container ">
          <Button size="large" icon labelPosition="right" onClick={handleSubmitName}>
            <Icon name="angle double right" />
            {Utility.ucFirst(props.translations.next)}
          </Button>
        </div>
      </>
    )
  }


  /**
   * Retourne le formulaire du num resa
   * @returns {object} jsx
   */
  const getFormNumResa = () => {
    return (
      <>
        {getHeader('numResa')}
        <Form.Input
          fluid
          icon="user"
          iconPosition="left"
          placeholder={props.translations.yourBookingNumber}
          id="inputNumResaSelfCheckin"
          name="inputNumResaSelfCheckin"
          // pattern={Utility.getPattern('mail')}
          // required
        />

        <div className="ui left aligned container ">
          <a href="#forgot" onClick={handleClickUrlBack}>
            <Icon name="arrow left" />
            {Utility.ucFirst(props.translations.back)}
          </a>
        </div>

        <div className="ui center aligned container ">
          <Button primary size="large" onClick={handleSubmitNumResa}>
            {Utility.ucFirst(props.translations.valid)}
          </Button>
        </div>
      </>
    )
  }

  const onIdle = () => {
    // Close Modal Prompt
    // Do some idle action like log out your user
    window.location.reload()
  }

  const idleTimer = useIdleTimer({  onIdle,
                                    startOnMount : false,
                                    debounce : 250,
                                   });

  /*<IdleTimer
        startOnMount={false}
        element={document}
        onIdle={() =>  window.location.reload()}
        debounce={250}
        timeout={2 * 1000 * 60}
      />*/
  return (
    <>
      
      <Form name="formSelfCheckin" id="formSelfCheckin" size="large" autoComplete="off">
        <Segment stacked className="p-4 segmentNotBoxShadow">
          <div id="divSlide">
            <List horizontal>
              <List.Item key="name" id="blockName">
                {stageState === 'name' ? getFormName() : null}
              </List.Item>

              <List.Item key="numResa" id="blockNumResa">
                {stageState === 'numResa' ? getFormNumResa() : null}
              </List.Item>
            </List>
          </div>
        </Segment>
      </Form>
    </>
  )
}
export default LoginBoxSelfCheckin;
